import React from "react";
import { Button, Spinner } from "reactstrap";
import { countFixedChanges } from "../../../../services/writingAssistantApi";
import WritingPreviewLiveValidationBanner from "./WritingPreviewLiveValidationBanner";

export default function WritingPreviewToolbar({
	changeCount = 0,
	validations = [],
	isSubmitting = false,
	isPolling = false,
	isLoadingValidations = false,
	validationStatusLabel = null,
	onVerify,
	onJumpToEdits,
	onDebugOpen,

	// Edit toolbar plumbing (optional, omitted when editing not wired)
	// These still gate the Verify-button edit lock on the live-validation banner;
	// they're intentionally NOT shown anywhere else in the toolbar per UX ask.
	editingEnabled = false,
	isDirty = false,
	isSaving = false,
}) {
	const latestCompleted = validations.find(
		(v) => String(v?.status || "").toLowerCase() === "completed"
	);
	const fixedCount = countFixedChanges(latestCompleted);
	const variant = validations.length === 0 ? "initial" : "reverify";
	const showLiveValidationBanner = changeCount > 0;

	// Verify button should be disabled while drafts are unsaved or save is in
	// flight – the backend will reject preview edits on an in-progress saved job
	// that hasn't been through its pipeline again.
	const verifyDisabledByEdits = editingEnabled && (isDirty || isSaving);

	return (
		<>
			{showLiveValidationBanner && (
				<WritingPreviewLiveValidationBanner
					variant={variant}
					fixedCount={fixedCount}
					totalCount={changeCount}
					// Don't visually mask isSubmitting/isPolling with edit state; only
					// disable the click handler + add a disabled flag when edits lock it.
					isSubmitting={Boolean(isSubmitting)}
					isPolling={Boolean(isPolling || isLoadingValidations)}
					statusLabel={validationStatusLabel}
					onVerify={verifyDisabledByEdits ? undefined : onVerify}
					verifyDisabledByEdits={verifyDisabledByEdits}
				/>
			)}

			<div className="writing-preview__toolbar">
				<div className="writing-preview__toolbar-left">
					<h2 className="writing-preview__toolbar-title">
						<i className="fas fa-magic writing-preview__sparkle me-2" />
						AI writing preview
					</h2>
					<p className="writing-preview__toolbar-subtitle text-muted mb-2">
						Scroll to highlight each change automatically, or click a change in the sidebar to
						jump to it. Click <strong>Edit</strong> on any card to refine the AI text, then
						click <strong>Save</strong> on the card.
					</p>
					<div className="writing-preview__legend">
						<span className="writing-preview__legend-item">
							<span className="writing-preview__legend-dot writing-preview__legend-dot--updated" />
							Updated by AI
						</span>
						<span className="writing-preview__legend-item">
							<span className="writing-preview__legend-dot writing-preview__legend-dot--added" />
							Added by AI
						</span>
					</div>
				</div>
				<div className="writing-preview__toolbar-actions">
					<Button
						color="light"
						className="writing-preview__toolbar-btn border"
						onClick={onJumpToEdits}
					>
						<i className="fas fa-crosshairs me-2" />
						Jump to edits
					</Button>
					{/* <Button
						color="light"
						className="writing-preview__toolbar-btn border"
						onDebugOpen={onDebugOpen}
					>
						<i className="fas fa-bug me-2" />
						Debug
					</Button> */}
				</div>
			</div>
		</>
	);
}
